export default class Translator {
    // eslint-disable-next-line class-methods-use-this
    trans(key, params = {}, domain = null) {
        return window.Translator.trans(key, params, domain);
    }
}
